<template>
  <section class="header-game">
    <div class="header-game__head-info">
      <div class="header-game__head-info__cont-live" v-if="showLive">
        <div class="header-game__head-info__cont-live__live">
          <div></div>
          <div>En vivo</div>
        </div>
      </div>
      <div v-else-if="showPostMatchData" class="header-game__head-info__finished">Finalizado</div>
      <div v-else class="header-game__head-info__hour">
        {{ date }}
      </div>
    </div>
    <div class="header-game__cont-info">
      <div class="header-game__cont-info__team-left">
        <div class="header-game__cont-info__team-left__img"><img :src="homeTeam.logo" /></div>
        <div class="header-game__cont-info__team-left__name">
          <span class="header-game__cont-info__team-left__name__movil">{{ homeTeam.acronym }}</span>
          <span class="header-game__cont-info__team-left__name__pc">{{ homeTeam.colloquial_name }}</span>
        </div>
      </div>
      <div v-if="gameForAnalysis.is_live">
        <span v-if="showLive" class="live-vs"> VS </span>
      </div>
      <div v-else-if="gameForAnalysis.game_status !== 4">

        <div class="header-game__cont-info__score">
          <div v-if="penaltiesResult" class="penalties">({{ penaltiesResult[0] }})</div>
          {{ getHomeResultGame }}&nbsp; · &nbsp;{{
            getAwayResultGame
          }}
          <div v-if="penaltiesResult" class="penalties">({{ penaltiesResult[1] }})</div>
        </div>
      </div>
      <div class="header-game__cont-info__team-right">
        <div class="header-game__cont-info__team-right__name">
          <span class="header-game__cont-info__team-right__name__movil">{{ visitingTeam.acronym }}</span>
          <span class="header-game__cont-info__team-right__name__pc">{{ visitingTeam.colloquial_name }}</span>
        </div>
        <div class="header-game__cont-info__team-right__img"><img :src="visitingTeam.logo" /></div>
      </div>
    </div>
  </section>
</template>

<script>
import options from '@/data/next/options';
import { mapGetters, mapState } from 'vuex';
export default {
  name: 'HeaderGame',
  components: {},
  props: {
    size: {
      type: Number,
      required: true,
    },
    availableGames: {
      type: Array,
      default: () => [],
    },
    areGamesVisible: {
      type: Boolean,
      default: false,
    },
    isInnerComponent: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    availableGames: {
      deep: true,
      handler(newValue) {
        this.selectedGame = newValue[0];
      },
    },
    selectedGame: {
      deep: true,
      handler(newValue) {
        this.$emit('game-change', newValue);
      },
    },
    gameForAnalysis: {
      deep: true,
      handler(newValue) {
        if (this.availableGames && this.availableGames.length) {
          this.selectedGame = this.availableGames.find(game => game.game_id === newValue.game_id);
        }
      },
    },
  },
  data() {
    return { analysisTypeOptions: options.analysisTypeOptions, selectedGame: {} };
  },
  beforeMount() {
    this.$store.commit('nextGeneral/updateSelectedAnalysis', this.analysisTypeOptions[0]);
  },
  computed: {
    ...mapState('nextGeneral', ['gameForAnalysis']),
    ...mapGetters('nextGeneral', [
      'homeTeam',
      'visitingTeam',
      'showLive',
      'menuOptionActive',
      'showLiveData',
      'idAssetSelected',
      'game',
      'showPostMatchData',
      'getHomeResultGame',
      'getAwayResultGame',
    ]),
    penaltiesResult() {
      if (this.gameForAnalysis.penalties_score_home_team && this.gameForAnalysis.penalties_score_visiting_team) {
        return [this.gameForAnalysis.penalties_score_home_team, this.gameForAnalysis.penalties_score_visiting_team];
      }
      return null;
    },
    date() {
      var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

      var dateVal =
        new Date(this.gameForAnalysis.date_time_utc)
          .toLocaleDateString('es-MX', options)
          .replace('de', '')
          .replace('de', '')
          .replace(', ', ' ') +
        ', ' +
        this.formatAMPM(new Date(this.gameForAnalysis.date_time_utc)).toUpperCase();
      return dateVal;
    },
  },
  methods: {
    formatAMPM(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    },
  },

  async created() {},
};
</script>

<style lang="scss" scoped>
.header-game {
  width: 100%;
  height: 112px;
  overflow: hidden;
  @media screen and (max-width: 540px) {
    height: 51px;
  }
  // background: yellow;
  &__head-info {
    width: 100%;
    height: 18px;
    display: inline-flex;
    // background: green;
    margin-top: 10px;
    @media screen and (max-width: 540px) {
      height: 16px;
      margin-top: 0px;
      display: flex;
    }
    &__finished {
      font-family: 'Avenir-Demi';
      font-size: 14px;
      width: 100%;
      height: 18px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 18px;
      letter-spacing: -0.28px;
      text-align: center;
      color: #fff;
      @media screen and (max-width: 540px) {
        height: 16px;
        font-size: 11px;
        line-height: 21px;
      }
    }
    &__cont-live {
      display: block;
      width: 95px;
      height: 18px;
      margin: 0 auto;
      margin-top: -3px;
      @media screen and (max-width: 540px) {
        height: 10px;
        margin-top: -6px;
      }
      &__live {
        width: 70px;
        height: 18px;
        display: inline-flex;
        font-family: 'Avenir-Demi';
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 15px;
        text-align: center;
        color: #ffffff;
        border-radius: 5px;
        @media screen and (max-width: 540px) {
          height: 10px;
          font-size: 11px;
        }

        & > div:first-child {
          margin-top: 4px;
          height: 6px;
          width: 6px;
          border-radius: 50%;
          background-color: #cbee6d;
          margin-left: 4px;
          margin-right: 4px;
        }
      }
    }
    &__hour {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      margin-top: 0px;
      line-height: 18px;
      font-family: 'Avenir-Demi';
      letter-spacing: normal;
      text-align: center;
      color: #fff;
      width: 100%;
      height: 18px;
      text-transform: capitalize;
      @media screen and (max-width: 540px) {
        height: 16px;
        line-height: 21px;
        font-size: 11px;
      }
    }
  }
  &__cont-info {
    width: 100%;
    display: inline-flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    height: 73px;
    // background: red;
    @media screen and (max-width: 540px) {
      height: 35px;
    }

    & span.live-vs {
      margin: 0 0.3em;
      color: white;
      font-size: 2em;
    }

    &__team-left {
      width: 36%;
      height: 73px;
      // background: green;
      margin-left: 2%;
      display: inline-flex;
      justify-content: left;
      align-content: center;
      align-items: center;
      @media screen and (max-width: 540px) {
        height: 35px;
      }
      &__img {
        // background: brown;
        width: 72px;
        display: inline-flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        height: 72px;
        @media screen and (max-width: 540px) {
          height: 35px;
        }
        img {
          width: 70px;
          @media screen and (max-width: 540px) {
            width: 25px;
          }
        }
      }
      &__name {
        width: 100%;
        height: 72px;
        // background: magenta;
        display: inline-flex;
        justify-content: left;
        align-content: center;
        align-items: center;
        margin-left: 3%;
        @media screen and (max-width: 540px) {
          height: 35px;
        }
        &__movil {
          display: none;
          @media screen and (max-width: 540px) {
            display: inline-block;
            font-size: 15px;
            font-family: 'Avenir-Demi';
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.2;
            letter-spacing: -0.3px;
            text-align: center;
            color: #fff;
          }
        }
        &__pc {
          font-family: 'Avenir-Demi';
          font-size: 19px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 0.95;
          letter-spacing: -0.38px;
          text-align: center;
          color: #fff;
          @media screen and (max-width: 540px) {
            display: none;
          }
        }
      }
    }
    &__score {
      width: 24%;
      height: 73px;
      // background: rgb(209, 111, 46);
      display: inline-flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      font-size: 40px;
      font-weight: bold;
      font-family: 'Circular-Std-Bold', sans-serif;
      font-stretch: normal;
      font-style: normal;
      line-height: 0.58;
      letter-spacing: -0.8px;
      text-align: center;
      color: #fff;
      white-space: nowrap;
      @media screen and (max-width: 540px) {
        height: 35px;
        font-size: 23px;
      }
    }
    &__team-right {
      width: 36%;
      height: 73px;
      // background: rgb(46, 204, 209);
      margin-right: 2%;
      display: inline-flex;
      justify-content: right;
      align-content: center;
      align-items: center;
      @media screen and (max-width: 540px) {
        height: 35px;
        font-family: 'Avenir-Demi';
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        letter-spacing: -0.3px;
        text-align: center;
        color: #fff;
      }
      &__img {
        display: inline-flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        // background: brown;
        width: 72px;
        height: 72px;
        @media screen and (max-width: 540px) {
          height: 35px;
        }
        img {
          width: 70px;
          @media screen and (max-width: 540px) {
            width: 25px;
          }
        }
      }

      &__name {
        width: 100%;
        height: 72px;
        // background: magenta;
        display: inline-flex;
        justify-content: right;
        align-content: center;
        align-items: center;
        margin-right: 3%;
        @media screen and (max-width: 540px) {
          height: 35px;
        }
        &__movil {
          display: none;
          @media screen and (max-width: 540px) {
            display: inline-block;
          }
        }
        &__pc {
          font-family: 'Avenir-Demi';
          font-size: 19px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 0.95;
          letter-spacing: -0.38px;
          text-align: center;
          color: #fff;
          @media screen and (max-width: 540px) {
            display: none;
          }
        }
      }
    }
  }
}

.penalties {
  margin: 0.5em;
  font-size: 0.5em;

  @media screen and (max-width: 480px) {
    font-size: 0.6em;
  }
}
</style>
